<template>
    <f7-page
        name="Traits"
        class="onboardingBg"
    >
        <f7-navbar
            large
            title-large="Your Traits"
            large-transparent
            inner-class="onboardingBg"
        >
            <f7-nav-left>
                <f7-link
                    back
                    icon="ion-ios-arrow-left"
                />
            </f7-nav-left>
            <f7-nav-title>Your Traits</f7-nav-title>
        </f7-navbar>

        <f7-block>These settings affect what content you see in your feed. We store it on our servers to better understand our audience but never share any of this information with anyone else.</f7-block>
        <f7-list>
            <template v-for="(group, index) in traitsByGroup">
                <f7-list-item
                    v-if="group.name !== 'value'"
                    :title="group.name"
                    :key="`title-trait-${index}`"
                    :v-bind="`title-trait-${index}`"
                    :smart-select-params="smartSelectParams"
                    smart-select
                >
                    <select
                        :name="group.name"
                        @change="changeTrait"
                    >
                        <option :value="group.name">-</option>
                        <option
                            v-for="option in group.options"
                            :value="option.id"
                            :key="option.id"
                            :selected="myTraits.indexOf(option.id) > -1"
                        >{{ option.displayName }}</option>
                    </select>
                </f7-list-item>
                <f7-list-item
                    v-else
                    :title="group.options[0].displayName"
                    :key="`title-trait-${index}`"
                    :after="myValueTraits.indexOf(group.options[0].id) > -1 ? myValueTraits.indexOf(group.options[0].id) : '-'"
                />
            </template>
        </f7-list>

        <f7-block v-if="user.isAdmin">Hidden admin section for debugging Value Traits</f7-block>
        <f7-list v-if="user.isAdmin">
            <template v-for="(trait, index) in myValueTraits">
                <f7-list-item
                    v-if="trait !== null && traitsIndex[index]"
                    :title="traitsIndex[index].name"
                    :key="`title-trait-${index}`"
                    :v-bind="`title-trait-${index}`"
                    :after="trait"
                />
            </template>
        </f7-list>
    </f7-page>
</template>

<script>
export default {
    store: ['api', 'text', 'user', 'traits', 'traitsIndex', 'myTraits', 'myValueTraits'],
    data () {
        return {
            traitsByGroup: [],
            smartSelectParams: { closeOnSelect: true }
        };
    },
    computed: {},
    created: function () {
        this.getMyTraits();
    },
    mounted: function () { },
    methods: {
        changeTrait: function (e) {
            this.$http
                .post(`${this.api}/users/${this.user.id}/traits`, {
                    traitId: e.target.value
                })
                .then(
                    response => {
                        this.myTraits = response.body.traits || [];
                        this.myValueTraits = response.body.valueTraits || [];
                        f7.preloader.hide();
                    },
                    response => {
                        f7.preloader.hide();
                        f7.dialog.alert(response.body.message || 'Unknown error');
                    }
                );
        },
        getMyTraits: function () {
            f7.preloader.show();
            this.$http.get(`${this.api}/users/${this.user.id}/traits`).then(
                response => {
                    this.myTraits = response.body.traits || [];
                    this.myValueTraits = response.body.valueTraits || [];
                    this.getTraits();
                    f7.preloader.hide();
                },
                response => {
                    f7.preloader.hide();
                    f7.dialog.alert(response.body.message || 'Unknown error');
                }
            );
        },
        getTraits: function () {
            this.$http.get(`${this.api}/traits`).then(
                response => {
                    this.traits = response.body || {};
                    let currentTrait = '';
                    for (let i = 0; i < this.traits.length; i++) {
                        if (!this.traits[i].display) continue;
                        this.traits[i].isFirst = false;
                        if (this.traits[i].groupName === 'value' || this.traits[i].groupName !== currentTrait) {
                            this.traits[i].isFirst = true;
                            this.traitsByGroup.push({
                                name: this.traits[i].groupName,
                                options: [this.traits[i]]
                            });
                            currentTrait = this.traits[i].groupName;
                        } else {
                            this.traitsByGroup[this.traitsByGroup.length - 1].options.push(this.traits[i]);
                        }
                        this.traitsIndex[this.traits[i].id] = this.traits[i];
                    }
                },
                response => {
                    f7.dialog.alert(response.body.message || 'Unknown error');
                }
            );
        }
    }
};
</script>
<style lang="less" scoped>
@import '../../css/colors.less';
.block-title {
    text-align: center;
    text-transform: uppercase;
    font-size: 12px;
    color: black;
    font-weight: bold;
}
.list.inset {
    border: 3px solid @black;
    border-radius: 0px;
}
.center {
    text-align: center;
}
</style>
